module.exports = __webpack_public_path__ + "img/textilien_und_handwerk.0928405.svg";